import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, ContratoTerceirizadoStorage } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ContratoTerceirizadoStorageService extends BaseResourceService<ContratoTerceirizadoStorage> {

  constructor(
    protected injector: Injector
  ) {
    super(`contrato-terceirizado-storages`, injector);
  }

  public upload(arquivos: any[], orgao: number, terceirizado: number, descricao?: string, visivel_transparencia?: boolean): Observable<ContratoTerceirizadoStorage[]> {
    const formData = new FormData();
    for (let arquivo of arquivos) {
      formData.append('files', arquivo);
    }
    if (descricao) {
      formData.append('descricao', descricao);
    }
    if (visivel_transparencia)
      formData.append('visivel_transparencia', 'true');
    const headers = this.httpOptions();
    headers.headers = headers.headers.delete('Content-Type');

    return this.http.post<ContratoTerceirizadoStorage[]>(`${this.login.cidade.id}/${this.api}/upload/${orgao}/${terceirizado}`,
      formData, headers)
      .pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

}